import React, { useEffect, useState } from "react";
import { grouplist, realignmonthlydues } from "../../../services/admin";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { isAdmin } from "../../../utils/roles";

export default function Allloan() {
    const navigate= useNavigate();
    const [filterProduct, setFilterProduct] = useState([]);
    const [realigning, setRealigning] = useState(false);
    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 150,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
              return (
                <div className="text-center">
                  <a className="btn-sm btn-info me-2" onClick={() => navigate(`/loan/memberlist/${params.value}`)}>
                    <i className="fa fa-edit"></i> Select Group
                  </a>
                
                </div>
              );
            },
          },
        {
            headerName: "Group ID",
            field: "group_id",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Group Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Total Members",
            field: "member_count",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Due On",
            field: "group_due",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Collection Day",
            field: "group_collection_day",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Staff",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Branch",
            field: "branch_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Center",
            field: "group_center",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        setFilterProduct([]);
        const temp=new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }


    // Monthly dues used to be stepped by a flat 30 days, which walks the due
    // date backwards until two dues land in one calendar month and none in the
    // next — the monthly report then reads uneven for schemes that are the same
    // every month. New loans are generated correctly; this repairs the ones
    // already saved. Lists the moves first, and only writes once confirmed.
    const handleRealign = () => {
        setRealigning(true);

        realignmonthlydues(true).then((res) => {
            setRealigning(false);

            if (res?.status !== true) {
                return;
            }

            if (!res.data?.count) {
                Swal.fire({
                    title: "Nothing to realign",
                    text: "Every monthly due already falls on a calendar month.",
                    icon: "success",
                });
                return;
            }

            const rows = (res.data.changes || [])
                .map(
                    (c) =>
                        `<tr><td>${c.loan_id}</td><td>${c.installment}</td>` +
                        `<td>${c.from}</td><td>${c.to}</td></tr>`
                )
                .join("");
            const more =
                res.data.count > (res.data.changes || []).length
                    ? `<p class="mt-2">…and ${res.data.count - res.data.changes.length} more.</p>`
                    : "";

            Swal.fire({
                title: "Realign monthly dues?",
                html:
                    `<p>${res.data.count} due date(s) across ${res.data.loans} loan(s) ` +
                    `will move onto calendar months.</p>` +
                    `<div style="max-height:260px;overflow:auto">` +
                    `<table style="width:100%;font-size:13px" border="1" cellpadding="4" cellspacing="0">` +
                    `<thead><tr><th>Loan</th><th>Ins</th><th>From</th><th>To</th></tr></thead>` +
                    `<tbody>${rows}</tbody></table></div>${more}` +
                    (res.data.skipped
                        ? `<p class="mt-2">${res.data.skipped} due(s) already paid or in the past will be left alone.</p>`
                        : ""),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, realign",
            }).then((result) => {
                if (!result.isConfirmed) {
                    return;
                }

                setRealigning(true);
                realignmonthlydues(false).then((runres) => {
                    setRealigning(false);
                    if (runres?.status === true) {
                        toast.success(runres.message);
                        funlist();
                    }
                });
            });
        }).catch(() => {
            setRealigning(false);
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">All Loan</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Loan</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        All Loan
                    </li>
                </ol>
            </div>

           
                <div className="content-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header d-md-flex align-items-center justify-content-between">
                                    <h2 className="main-content-title tx-24 mg-b-5">
                                        All Loan List
                                    </h2>
                                    {isAdmin() && (
                                        <button
                                            className="btn btn-warning"
                                            onClick={handleRealign}
                                            disabled={realigning}
                                            title="Move monthly due dates onto calendar months"
                                        >
                                            <i className="fa fa-refresh"></i>{" "}
                                            {realigning ? "Checking…" : "Realign Monthly Dues"}
                                        </button>
                                    )}
                                </div>
                                <div className="card-body">
                                    <div className="ag-theme-alpine ag-style mt-2">
                                        <AgGridReact
                                            columnDefs={columnDefs}
                                            rowData={filterProduct}
                                            pagination="true"
                                            paginationPageSize="10"
                                            sortingOrder={["asc", "desc"]}
                                            suppressDragLeaveHidesColumns={true}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );
}
